export default __webpack_public_path__ + "static/media/9a8b0b638395673481f58c01846a75711576777838802.c2d712d6.webp";